module.exports = __webpack_public_path__ + "img/silverIcon.46c00320.svg";